import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useUIStore, type Language } from '@/stores/uiStore';

const LANGUAGES: { code: Language; label: string }[] = [
  { code: 'fr', label: 'FR' },
  { code: 'en', label: 'EN' },
  { code: 'es', label: 'ES' },
];

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const setLanguage = useUIStore((s) => s.setLanguage);

  function change(lang: Language) {
    void i18n.changeLanguage(lang);
    setLanguage(lang);
  }

  return (
    <div
      className="inline-flex items-center gap-1 rounded-full border border-border bg-card p-1"
      role="radiogroup"
      aria-label={t('common.language')}
    >
      <Languages size={14} className="ml-2 text-muted" aria-hidden />
      {LANGUAGES.map(({ code, label }) => {
        const active = i18n.resolvedLanguage === code;
        return (
          <button
            key={code}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => change(code)}
            className={
              'rounded-full px-2.5 py-1 text-xs font-semibold transition ' +
              (active
                ? 'bg-primary text-white shadow-soft'
                : 'text-muted hover:text-ink hover:bg-bg')
            }
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
